import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <Stack className="page-not-found">
            <Typography variant="h4">404 — Page Not Found</Typography>
            <Typography variant="body1">Sorry, we couldn’t find the page you’re looking for.</Typography>
            <Button variant="contained" startIcon={<ArrowBack />} onClick={() => navigate('/')}>
                Back to home page
            </Button>
        </Stack>
    );
};
